import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 游戏步骤接口
export interface GameStep {
  type: string;
  step?: number;
  positions?: number[];
  cards?: Array<{
    position: number;
    item_type: string;
    product_name: string;
    product_image?: string;
  }>;
  matched?: boolean;
  matched_position?: number;
  total_matches?: number;
  reward_product_name?: string;
  reward_product_image?: string;
}

// 游戏记录接口
export interface MatchGameRecord {
  id: number;
  match_pool_id: number;
  match_pool?: {
    id: number;
    name: string;
  };
  user_id: number;
  user?: {
    id: number;
    nickname: string;
    mobile: string;
  };
  payment_record_id?: number;
  pocket_item_id?: number;
  pocket_item?: {
    id: number;
    product_name: string;
    product_image?: string;
  };
  total_matches: number;
  reward_product_id?: number;
  reward_product?: {
    id: number;
    name: string;
    image?: string;
  };
  cost: number;
  steps: GameStep[];
  status: string;
  status_display?: string;
  created_at: string;
  updated_at: string;
}

@Module
export default class MatchGameRecordModule extends VuexModule {
  match_game_records_list = [] as Array<MatchGameRecord>;
  match_game_records_count = 0;
  match_game_record = {} as MatchGameRecord;

  get currentMatchGameRecordsList(): Array<MatchGameRecord> {
    return this.match_game_records_list;
  }

  get currentMatchGameRecord(): MatchGameRecord {
    return this.match_game_record;
  }

  get currentMatchGameRecordsCount(): number {
    return this.match_game_records_count;
  }

  @Mutation
  [Mutations.SET_MATCH_GAME_RECORDS_LIST](records_list: Array<MatchGameRecord>) {
    this.match_game_records_list = records_list;
  }

  @Mutation
  [Mutations.SET_MATCH_GAME_RECORD](record: MatchGameRecord) {
    this.match_game_record = record;
  }

  @Mutation
  [Mutations.SET_MATCH_GAME_RECORDS_COUNT](count: number) {
    this.match_game_records_count = count;
  }

  @Action
  [Actions.GET_MATCH_GAME_RECORDS](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/match_game_records", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_MATCH_GAME_RECORDS_LIST, data["match_game_records"] || []);
          this.context.commit(Mutations.SET_MATCH_GAME_RECORDS_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_MATCH_GAME_RECORD](id: number) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/match_game_records/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_MATCH_GAME_RECORD, data["match_game_record"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
